var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavGif(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50781 15.0977C6.82422 15.0977 5.79297 14 5.79297 12.1641V12.1602C5.79297 10.3555 6.82812 9.26562 8.48047 9.26562C9.83594 9.26562 10.7578 10.0547 10.9453 11.1133L10.957 11.168H9.77344L9.75781 11.1289C9.57031 10.582 9.12109 10.2656 8.48438 10.2656C7.55469 10.2656 6.99609 10.9531 6.99609 12.1484V12.1523C6.99609 13.375 7.58984 14.0977 8.52734 14.0977C9.29688 14.0977 9.82422 13.6406 9.85547 12.9453L9.85938 12.8633H8.57031V11.9844H11.0078V12.6328C11.0078 14.168 10.0781 15.0977 8.50781 15.0977ZM11.7891 15V9.36328H12.9688V15H11.7891ZM13.9062 15V9.36328H17.5977V10.3359H15.0859V11.8477H17.3789V12.7812H15.0859V15H13.9062Z",
    fill: "#707070"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 4.75,
    width: 22.5,
    height: 14.5,
    rx: 3.25,
    stroke: "#707070",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGif);
export default __webpack_public_path__ + "static/media/nav-gif.234d371476018f6ff10809b26f4c1433.svg";
export { ForwardRef as ReactComponent };